export const arrPartners = [
  {
    id: 1,
    title: "Gölcük Şehit Volkan Tantürk Mesleki ve Teknik Anadolu Lisesi",
    logo: "golcukMTAL.png",
    legalForm: "DEVLET TESSEBUSU",
    country: "Türkiye",

    descriptions: [
      {
        id: 1,
        text: "Gölcük ŞVT VET will be the general coordinator of the project. It is responsible for project management-WP1. The progress of the entire project process, monitoring, reporting and feedback will be monitored under the responsibility of this institution. An eTwinning project will be created with the start of the project. It will be created by coordinator institution. Each institution will designate a staff member responsible for the eTwinning project.",
      },
    ],
    tasks: [
      {
        id: 1,
        text: "preparation and maintenance of financial control and accounting,",
      },
      {
        id: 2,
        text: "cooperation with the coordinators of the project partners and monitoring the compliance with the deadlines",
      },
      {
        id: 1,
        text: "and checking whether the planned results are achieved.",
      },
    ],
    items: [
      {
        id: 1,
        label: "Organisation ID (OID)",
        children: "E10194029",
      },
      {
        id: 2,
        label: "Organization Role",
        children: "Applicant Organisation",
      },
      {
        id: 3,
        label: "Address",
        children:
          "Kavaklı Mahallesi, Adnan Menderes Bulvarı No:53 41650 KOCAELİ",
      },
      {
        id: 4,
        label: "Organisation Type",
        children:
          "School/Institute/Educational Centre - Vocational Training (secondary level)",
      },
      {
        id: 5,
        label: "VAT Number",
        children: "4070233709",
      },
      {
        key: 6,
        label: "Registration Number",
        children: "174298",
      },
    ],
  },

  {
    id: 2,
    title: "LudusXR Aps",
    logo: "ludusXR.png",
    legalForm: "ANPARTSELSKAB",
    country: "Denmark",

    descriptions: [
      {
        id: 1,
        text: 'LudusXR (DK) is responsible for the WP2 "Creating the simulation".The institution is an experienced educational software developer in the field of education.It will host the 2nd International meeting to be held during the creation of the simulation,',
      },
      {
        id: 2,
        text: "And also the dissemination meeting will be held in Denmark at the end of the project, and the first training event(LTT1) will be held after the simulation is created. They will work with Limon Inc to create the simulation.",
      },
    ],
    tasks: [
      {
        id: 1,
        text: "Analysis of current opportunities for simulator development,",
      },
      {
        id: 2,
        text: "selection of the most successful solution to be provided,",
      },
      {
        id: 3,
        text: "successful simulator work,",
      },
      {
        id: 4,
        text: "development of graphic design of simulation,",
      },
      {
        id: 5,
        text: "transforming spatial objects for processing",
      },
      {
        id: 6,
        text: "integration of components into the whole object",
      },
    ],
    items: [
      {
        key: 1,
        label: "Organisation ID (OID)",
        children: "E10245629",
      },
      {
        key: 2,
        label: "Organization Role",
        children: "Partner Organisation",
      },
      {
        key: 3,
        label: "Address",
        children: "Villestoftedalen 1 5210 Odense NV",
      },
      {
        key: 4,
        label: "Organisation Type",
        children: "Small and medium sized enterprise",
      },
      {
        key: 5,
        label: "VAT Number",
        children: "42347701",
      },
      {
        key: 6,
        label: "Registration Number",
        children: "42347701",
      },
    ],
  },

  {
    id: 3,
    title: "SVEUCLISTE U RIJECI",
    logo: "rijeci.png",
    legalForm: "USTONOVA",
    country: "Croatia",
    descriptions: [
      {
        id: 1,
        text: "Rijeka,(HR) is the university with maritime faculty. It will host the 3rd international meeting, and the dissemination meeting will be held in Croatia at the end of the project, and the 2nd training event(LTT2).It is the leading organization in the creation of WP3 application pages.",
      },
    ],
    tasks: [
      {
        id: 1,
        text: "Creation of the pedagogical structure of the worksheets,",
      },
      {
        id: 2,
        text: "They will support the pedagogical design of the content of the simulation and the structure of the training platform.",
      },
    ],
    items: [
      {
        key: 1,
        label: "Organisation ID (OID)",
        children: "",
      },
      {
        key: 2,
        label: "Organization Role",
        children: "E10195716",
      },
      {
        key: 3,
        label: "Address",
        children: "TRG BRACE MAZURANICA 10 51000 RIJEKA",
      },
      {
        key: 4,
        label: "Organisation Type",
        children: "Higher education institution (tertiary level)",
      },
      {
        key: 5,
        label: "VAT Number",
        children: "HR64218323816",
      },
      {
        key: 6,
        label: "Registration Number",
        children: "040131108",
      },
    ],
  },
  {
    id: 4,
    title: "Nikola Vaptsarov Naval Academy",
    logo: "nikola.png",
    legalForm: "UNKNOWN",
    country: "Bulgaria",
    descriptions: [
      {
        id: 1,
        text: "Nikola Vaptsarov Naval Academy (BG) is responsible for WP1.2, quality management.It is the leader in following the quality standards determined throughout the whole process.It will host the 4th international meeting and the dissemination meeting to be held in Bulgaria at the end of the project.",
      },
    ],
    tasks: [
      {
        id: 1,
        text: "Creation of the pedagogical structure of the worksheets,",
      },
      {
        id: 2,
        text: "They will support the pedagogical design of the content of the simulation and the structure of the training platform.",
      },
    ],
    items: [
      {
        key: 1,
        label: "Organisation ID (OID)",
        children: "E10108590",
      },
      {
        key: 2,
        label: "Organization Role",
        children: "Partner Organisation",
      },
      {
        key: 3,
        label: "Address",
        children: "73 Vasil Drumev Str. 9023 Varna",
      },
      {
        key: 4,
        label: "Organisation Type",
        children: "Higher education institution (tertiary level)",
      },
      {
        key: 5,
        label: "VAT Number",
        children: "BG129004492",
      },
      {
        key: 6,
        label: "Registration Number",
        children: "129004492",
      },
    ],
  },
  {
    id: 5,
    title: "Sea Teach S.L.",
    logo: "seaTeach.png",
    legalForm: "SOCIEDAD LIMITADA",
    country: "Spain",
    descriptions: [
      {
        id: 1,
        text: "Sea Teach SL (ES) is a regional VET and Adult Education Center which provides courses for  students from many different EU Countries aged from 18 to over.",
      },
      {
        id: 2,
        text: "It will host the 6th international meeting and the dissemination meeting to be held in Spain at the end of the project and will be the leading organization for dissemination.",
      },
    ],
    tasks: [
      {
        id: 1,
        text: "It will support adult education that is another target group of our project.It is also responsible for the dissemination process of EPALE.",
      },
      {
        id: 2,
        text: "Social media accounts will be created and updated by this institution.",
      },
    ],
    items: [
      {
        key: 1,
        label: "Organisation ID (OID)",
        children: "E10115263",
      },
      {
        key: 2,
        label: "Organization Role",
        children: "Partner Organisation",
      },
      {
        key: 3,
        label: "Address",
        children: "Port Petit 1, Local 208 07660 Cala D`or",
      },
      {
        key: 4,
        label: "Organisation Type",
        children: "Small and medium sized enterprise",
      },
      {
        key: 5,
        label: "VAT Number",
        children: "ESB57010845",
      },
      {
        key: 6,
        label: "Registration Number",
        children: "PM35599",
      },
    ],
  },
  {
    id: 6,
    title: "Limon TEknoloji Yazılım ve Donanım Tic. Ltd. Şti.",
    logo: "limonTech.png",
    legalForm: "LIMITED SIRKET",
    country: "Türkiye",
    descriptions: [
      {
        id: 1,
        text: "Limon company is a mobile software developer.The main activity areas are robotics projects and trainings, R&D studies, software development, electronics & robotics, equipment design, web page design.It is the leading institution in the project's WP4.",
      },
      {
        id: 2,
        text: "Online education platform.It'll host 3 training events (LTT3) to be held after the online training platform is completed.",
      },
      {
        id: 3,
        text: "Limon company will perform the background coding of the simulation to be created.",
      },
      {
        id: 4,
        text: "They will cooparate and collaborate with LUDUS XR",
      },
    ],
    tasks: [],
    items: [
      {
        key: 1,
        label: "Organisation ID (OID)",
        children: "E10300862",
      },
      {
        key: 2,
        label: "Organization Role",
        children: "Partner Organisation",
      },
      {
        key: 3,
        label: "Address",
        children:
          "Barbaros Mahallesi Kardelen Sokak Palladium Tower No:2/10 Ataşehir 34746 İstanbul",
      },
      {
        key: 4,
        label: "Organisation Type",
        children: "Small and medium sized enterprise",
      },
      {
        key: 5,
        label: "VAT Number",
        children: "6090533761",
      },
      {
        key: 6,
        label: "Registration Number",
        children: "",
      },
    ],
  },
  {
    id: 7,
    title: "Second Epal Neas Ionias Volou",
    logo: "ionas.png",
    legalForm: "UNKNOWN",
    country: "Greece",
    descriptions: [
      {
        id: 1,
        text: "SECOND EPAL NEAS IONIAS VOLOU (GR) is a vocational education institution with more than 1000 students, providing education in the fields of mechanics, electronics/electricity, information technologies and maritime.It'll support Limon company in the design of the online education platform and will host the 5th international meeting to be held in this process and the dissemination meeting to be held in Greece at the end of the project.",
      },
      {
        id: 2,
        text: "The preparation of the project web page and the creation of the online education platform are the responsibility of this institution.They will work together with LudusXR and limon software companies.",
      },
    ],
    tasks: [],
    items: [
      {
        key: 1,
        label: "Organisation ID (OID)",
        children: "E10181323",
      },
      {
        key: 2,
        label: "Organization Role",
        children: "Partner Organisation",
      },
      {
        key: 3,
        label: "Address",
        children: "Melinas Merkouri & Agiou Nektariou 384 46 Volos",
      },
      {
        key: 4,
        label: "Organisation Type",
        children:
          "School/Institute/Educational Centre - Vocational Training (secondary level)",
      },
      {
        key: 5,
        label: "VAT Number",
        children: "",
      },
      {
        key: 6,
        label: "Registration Number",
        children: "not applicable",
      },
    ],
  },
];
